export default async function fetchTemplates({ commit, rootGetters, dispatch }) {
    try {
        commit('SET_FETCH_TEMPLATES_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const url = `/proxy/ai/document-analysis/extract-templates?customer_id=${customer_id}`;
        const response = await window.axios.get(url);

        if (response.data.success) {
            const templates = response.data.data?.extractTemplates || [];
            commit('SET_TEMPLATES', templates);
        } else {
            dispatch('notifications/setError', 'Failed to fetch extract templates', { root: true });
        }
    } catch (error) {
        console.error('Error fetching extract templates:', error);
        dispatch('notifications/setError', 'Failed to fetch extract templates', { root: true });
    } finally {
        commit('SET_FETCH_TEMPLATES_LOADING', false);
    }
}